import { TICKETS_REQUEST, TICKETS_SUCCESS, TICKETS_FAILURE } from 'app/actions/assistance/tickets';
import { TICKET_FORM_SEND_SUCCESS } from 'app/actions/assistance/ticketForm';
import update from 'react-addons-update';

export const expiredInterval = 600000; // 10min
const defaultState = {
  loading: false,
  tickets: {},
  result: null,
  expired: Date.now(),
};

const tickets = (state = defaultState, action) => {
  switch (action.type) {

    case TICKETS_REQUEST: {
      return { ...state, loading: true };
    }

    case TICKETS_SUCCESS: {
      return { ...state, ...action.payload, loading: false, expired: Date.now() + expiredInterval };
    }

    case TICKETS_FAILURE: {
      return { ...state, loading: false, result: null };
    }

    case TICKET_FORM_SEND_SUCCESS: {
      return update(state, { tickets: { $merge: action.payload } });
    }

    default:
  }
  return state;
};

export default tickets;
